import React from 'react';
import Divider from '../components/Divider';

export default class Services extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <div className={'container'}>
                <Divider marginBotom={70} />
                <div>
                    <div
                        className="big-title animated fadeInDown delay-01"
                        data-animation="fadeInDown"
                        data-animation-delay="01"
                    >
                        <h2 className="iwh-title">
                            STAP<span className="accent-color">MEDIF</span>,
                            partenaire de référence pour la gestion de vos
                            appels et la prise de rendez-vous
                        </h2>
                    </div>
                    <p className="">
                        Optimisez vos ressources, pilotez votre activité et
                        augmentez votre productivité grâce à nos prestations :
                    </p>
                    <div className="shortcode-simple-list icon">
                        <ul>
                            <li>
                                <i className="accent-color fa fa-hand-o-right"></i>
                                la <b>réception de vos appels entrants</b>, de
                                8.30 à 19.00 du lundi au vendredi et de 8.30 à
                                13.00 le samedi
                            </li>
                            <li>
                                <i className="accent-color fa fa-hand-o-right"></i>
                                la <b>prise de rendez-vous</b>, par la mise à
                                disposition d’un planning web développé par nos
                                soins ou en interface avec votre <b>RIS</b>
                            </li>
                            <li>
                                <i className="accent-color fa fa-hand-o-right"></i>
                                l’envoi des convocations et ordonnances,
                                incluant les consignes préparatoires et les
                                points de vigilance
                            </li>
                            <li>
                                <i className="accent-color fa fa-hand-o-right"></i>
                                la confirmation des rendez-vous et le rappel par
                                sms
                            </li>
                        </ul>
                    </div>
                </div>
                <Divider type="5" />
                <div>
                    <div
                        className="big-title animated fadeInDown delay-01"
                        data-animation="fadeInDown"
                        data-animation-delay="01"
                    >
                        <h2 className="iwh-title">
                            L’imagerie médicale est notre métier
                        </h2>
                    </div>
                    <p className="">
                        Toutes nos <b>secrétaires médicales</b> sont diplômées
                        et formées aux particularités de votre spécialité. Leurs
                        compétences sont régulièrement actualisées grâce à nos{' '}
                        <b>médecins radiologues</b> associés. Supervisées par
                        des référentes, elles bénéficient d’un parcours
                        d’intégration pour connaître votre groupe, vos pratiques
                        et habitudes de travail. Elles assurent un{' '}
                        <b>accueil téléphonique</b> professionnel et courtois
                        qui valorise votre image.
                    </p>
                </div>
                <Divider type="5" />
                <div>
                    <div
                        className="big-title animated fadeInDown delay-01"
                        data-animation="fadeInDown"
                        data-animation-delay="01"
                    >
                        <h2 className="iwh-title">
                            Une méthodologie rigoureuse pour une externalisation
                            réussie de votre secrétariat
                        </h2>
                    </div>
                    <p className="">
                        A chaque étape de votre projet, vous bénéficiez d’un
                        accompagnement personnalisé. Après un recueil minutieux
                        de vos pratiques et de vos attentes, un protocole formel
                        fixe les conditions de notre collaboration.{' '}
                        <b>Permanence téléphonique</b>, consignes de{' '}
                        <b>planification des rendez-vous</b>, modalités de
                        connexion et de communication : rien n’est laissé au
                        hasard. Du déploiement à la production, vous êtes en
                        contact permanent avec vos interlocuteurs dédiés. Pour
                        ses clients, <b>STAPMEDIF</b> s’engage : des bilans
                        réguliers et des rapports mensuels vous permettent de
                        suivre notre activité.
                    </p>
                </div>
                <Divider type="5" />
                <div>
                    <div
                        className="big-title animated fadeInDown delay-01"
                        data-animation="fadeInDown"
                        data-animation-delay="01"
                    >
                        <h2 className="iwh-title">
                            Une offre ajustable et évolutive
                        </h2>
                    </div>
                    <div className="shortcode-simple-list icon">
                        <ul>
                            <li>
                                <i className="accent-color fa fa-hand-o-right"></i>
                                Des formules sur mesure adaptées à vos besoins :{' '}
                                <b>externalisation</b> totale ou partielle,
                                débordement sur des créneaux horaires
                                identifiés, prise en charge d’un nombre d’appels
                                prédéfini…
                            </li>
                            <li>
                                <i className="accent-color fa fa-hand-o-right"></i>
                                Une facturation claire et transparente, sans
                                engagement
                            </li>
                        </ul>
                    </div>
                    <Divider type="5" />
                    <p>
                        Vous gérez un groupe d’<b>imagerie médicale</b> et vous
                        rencontrez des problématiques spécifiques ? Frappe de
                        comptes-rendus, audit de votre organisation,
                        optimisation de vos interfaces métier <b>RIS et PACS</b>{' '}
                        : partout en France, <b>STAPMEDIF</b> vous accompagne.
                        Contactez-nous.
                    </p>
                </div>
                <Divider />
            </div>
        );
    }
}

Services.propTypes = {};



// WEBPACK FOOTER //
// ./src/routes/Services.jsx